import { useState, useCallback } from 'react';

const STORAGE_KEY = 'useOptimisedReports';

function readFromStorage(): boolean {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) === true : true;
  } catch {
    return true;
  }
}

export default function useOptimisedReports(): [boolean, (val: boolean) => void] {
  const [value, setValue] = useState<boolean>(readFromStorage);

  const setOptimisedReports = useCallback((val: boolean) => {
    setValue(val);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(val));
  }, []);

  return [value, setOptimisedReports];
}
